import React from 'react';

interface AssistanceNumberProps {
    mobileNumber: string;
}

const AssistanceNumber = (props: AssistanceNumberProps): JSX.Element => {
    const { mobileNumber } = props;
    return (
        <div style={{ marginTop: 20, padding: '0 10px' }}>
            <span
                style={{
                    fontFamily: 'AcuminRPro',
                    fontSize: 14,
                    color: '#616161',
                    fontWeight: 500,
                    marginRight: 5,
                }}
            >
                Need assistance? Chat now or call us at
            </span>
            <a
                href={`tel:${mobileNumber}`}
                style={{
                    fontFamily: 'AcuminRPro',
                    fontSize: 14,
                    color: '#064E72',
                    fontWeight: 500,
                    textDecoration: 'underline',
                }}
            >
                {mobileNumber}
            </a>
        </div>
    );
};

export default AssistanceNumber;
